import React, { Component } from 'react';
import { Rect, Text, Group } from 'react-konva';

export class HorizontalStopsListComponentCanvas extends Component {
    render() {
        const { component, isSelected, dimentionsRatio, draggable } = this.props;

        const componentWidthRatio = component.width / 1200.0 * dimentionsRatio;
        const componentHeightRatio = component.height / 400.0 * dimentionsRatio;

        const textElementPosX = component.drawPositionX + 50 * componentWidthRatio;
        const textElementPosY = component.drawPositionY + 350 * componentHeightRatio;

        const componentSecundaryColor = "#C3E2F0";
        const componentWidth = component.width * dimentionsRatio;
        const componentHeight = component.height * dimentionsRatio;

        let fontSize = 35;
        if (6 * fontSize > componentHeight) {
            fontSize = componentHeight / 6.0;
        }
        if(fontSize > componentWidth) {
            fontSize *= componentWidth / fontSize;
        }

        const rectElements = [];
        let nextRectPosX = textElementPosX + fontSize + 10;
        const rectPosY = component.drawPositionY + 50 * componentHeightRatio;
        const rectHeight = 300 * componentHeightRatio;
        const rectWidth = 20;

        const widthLimit = componentWidth + component.drawPositionX - 5;
        while (widthLimit > nextRectPosX + rectWidth) {
            rectElements.push(
                <Group key={nextRectPosX}>
                    <Rect x={nextRectPosX}
                        y={rectPosY}
                        width={rectWidth}
                        height={rectHeight}
                        strokeWidth={1}
                        stroke="black"
                        fill={componentSecundaryColor} />
                </Group>
            );

            nextRectPosX += rectWidth + 10;
        }

        return (
            <Group
                offsetX={component.offsetX}
                offsetY={component.offsetY}
                draggable={draggable}
                onDragEnd={this.props.onDragEnd}
                onClick={this.props.onComponentClick ? () => this.props.onComponentClick(component.internalId) : null} >
                <Rect x={component.drawPositionX}
                    y={component.drawPositionY}
                    width={componentWidth}
                    height={componentHeight}
                    strokeWidth={isSelected ? 3 : 1}
                    stroke={isSelected ? "#6699ff" : "black"}
                    fill={component.color} />

                <Group>
                    <Text text="Espinha"
                        fontSize={fontSize}
                        x={textElementPosX}
                        y={textElementPosY}
                        rotation={-90} />
                </Group>

                {rectElements}
            </Group>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/bussched/layoutConfigurations/componentCanvas/HorizontalStopsListComponentCanvas.js